// extracted by mini-css-extract-plugin
export var card = "PortfolioItem-module--card--py8oC";
export var card__imageWrap = "PortfolioItem-module--card__imageWrap--2vLLY";
export var card__imageWrap__tags = "PortfolioItem-module--card__imageWrap__tags--1JgDi";
export var card__imageWrap__tags__text = "PortfolioItem-module--card__imageWrap__tags__text--2qwqn";
export var card__title = "PortfolioItem-module--card__title--25_kq";
export var card__subtitle = "PortfolioItem-module--card__subtitle--3hWV6";